'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import { InvoiceDetailProvider } from '../components/common/InvoiceContext';
import Appeals from '../components/appeals/Appeals';

export default function AppealsPage() {
  return (
    <PageLayout
      title="Current Appeals Queue"
      description="Review and manage current appeals queue."
    >
      <MatterArDetailProvider>
        <InvoiceDetailProvider>
          <Appeals />
        </InvoiceDetailProvider>
      </MatterArDetailProvider>
    </PageLayout>
  );
}
